/* ==========================================================================
   FLC Forge — Product Siblings
   Fetches colour siblings for product cards using Shopify section rendering.
   Requires: custom.product_siblings metafield (group key) indexed by
             Search & Discovery app for the search query to return results.
   ========================================================================== */

(function initProductSiblings() {
  const SECTION_ID   = 'product-siblings-row';
  const in_progress  = new Set();

  async function loadSiblings(container) {
    const key            = container.dataset.siblingsKey;
    const currentHandle  = container.dataset.currentHandle;
    if (!key || in_progress.has(key)) return;

    in_progress.add(key);

    try {
      const url = `/search?type=product&q=${encodeURIComponent('tag:' + key)}&sections=${SECTION_ID}`;
      const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;

      const data = await res.json();
      const html = data[SECTION_ID];
      if (!html) return;
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      // Find all containers sharing the same group key (multiple cards on the page)
      const allContainers = document.querySelectorAll(`[data-siblings-key="${CSS.escape(key)}"]`);

      allContainers.forEach(target => {
  const thisHandle = target.dataset.currentHandle;

  doc.querySelectorAll('[data-sibling]').forEach(node => {
    const handle = node.dataset.sibling;
    if (handle === thisHandle) return; // skip current product
    if (target.querySelector(`[data-sibling="${CSS.escape(handle)}"]`)) return; // already added
    target.appendChild(node.cloneNode(true));
  });
});
    } catch (_) {
      // Fail silently — siblings are progressive enhancement
    } finally {
      in_progress.delete(key);
    }
  }

  function observe(root) {
    root.querySelectorAll('[data-siblings-key]').forEach(loadSiblings);
  }

  observe(document);

  new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-siblings-key]')) loadSiblings(node);
        else node.querySelectorAll?.('[data-siblings-key]').forEach(loadSiblings);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
